/**
 * Google Fonts a merchant can pick for the checkout via Checkout Studio. Keep in
 * sync with the studio's `FONT_FAMILIES` list (dashboard `studio/options.ts`).
 */
export const FONT_FAMILIES = [
  "Inter",
  "Roboto",
  "Open Sans",
  "Lato",
  "Poppins",
  "Montserrat",
] as const;

export type FontFamily = (typeof FONT_FAMILIES)[number];

const FALLBACK_STACK =
  'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

export function isSupportedFont(
  value: string | undefined | null
): value is FontFamily {
  return !!value && (FONT_FAMILIES as readonly string[]).includes(value);
}

export function fontFamilyStack(font: FontFamily): string {
  return `"${font}", ${FALLBACK_STACK}`;
}

const injected = new Set<FontFamily>();

export function loadGoogleFont(font: FontFamily): void {
  if (injected.has(font)) return;
  injected.add(font);

  const family = font.replace(/ /g, "+");
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${family}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
}
